import { type FormEvent, useState } from 'react';

import { Btn } from '../../components/Btn';
import { Modal } from '../../components/Modal';
import { dashboardApi } from '../../lib/apiClient';

export function ChangePasswordModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setMessage('');
    if (newPassword.length < 8) {
      setMessage('รหัสผ่านใหม่ต้องมีอย่างน้อย 8 ตัวอักษร');
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage('รหัสผ่านใหม่ไม่ตรงกัน');
      return;
    }
    setIsSubmitting(true);
    try {
      await dashboardApi.changePassword({ currentPassword, newPassword });
      setMessage('เปลี่ยนรหัสผ่านแล้ว');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch {
      setMessage('เปลี่ยนรหัสผ่านไม่สำเร็จ');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal open={open} title="เปลี่ยนรหัสผ่าน" onClose={onClose}>
      <form onSubmit={onSubmit} className="flex flex-col gap-4">
        <label className="flex flex-col gap-1.5">
          <span className="text-sm-label font-semibold text-ink-2">
            รหัสผ่านปัจจุบัน
          </span>
          <input
            aria-label="รหัสผ่านปัจจุบัน"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className="h-10 px-3 rounded-btn border border-line bg-surface text-body"
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-sm-label font-semibold text-ink-2">
            รหัสผ่านใหม่
          </span>
          <input
            aria-label="รหัสผ่านใหม่"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="h-10 px-3 rounded-btn border border-line bg-surface text-body"
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-sm-label font-semibold text-ink-2">
            ยืนยันรหัสผ่านใหม่
          </span>
          <input
            aria-label="ยืนยันรหัสผ่านใหม่"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="h-10 px-3 rounded-btn border border-line bg-surface text-body"
          />
        </label>
        {message && <div className="text-sm-label text-ink-2">{message}</div>}
        <div className="flex justify-end gap-2 pt-2">
          <Btn kind="default" type="button" onClick={onClose}>
            ปิด
          </Btn>
          <Btn kind="primary" type="submit" disabled={isSubmitting}>
            บันทึก
          </Btn>
        </div>
      </form>
    </Modal>
  );
}
